var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[(_vm.$route.name === 'home' || _vm.$route.name === 'purpose-case'
    || _vm.$route.name === 'dynamism-case' || _vm.$route.name === 'network-case'
    || _vm.$route.name === 'empowerment-case')?_c('navbar-main'):(_vm.$route.name === 'start')?_c('navbar-empty'):_c('navbar-evaluation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314cd2c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 